export default {
  INVALID_ID: 'ID must be a 9 digit number',
  LETTERS_ONLY: 'Name can only contain letters',
  USERNAME_CHARACTERS: 'Name can only contain alpha-numeric characters or underscore (_), and must begin with a letter or an underscore',
  USERNAME_LENGTH: 'Username must be 8 to 24 characters long',
  USERNAME_EXISTS: 'Username already exists',
  EMAIL_EXISTS: 'E-mail already exists',
  EMAIL_INVALID: 'Please enter a valid email address',
  NPI_EXISTS: 'NPI already exists',
  LICENSE_EXISTS: 'This professional license is already registered for this account',
  CERTIFICATE_EXISTS: 'This certificate number is already registered for this account',
  PASSWORD_LENGTH_MIN: 'Password must be at least 12 characters long',
  PASSWORD_REQUIRE_LOWER: 'Password must contain at least one lowercase letter',
  PASSWORD_REQUIRE_UPPER: 'Password must contain at least one uppercase letter',
  PASSWORD_REQUIRE_DIGIT: 'Password must contain at least one number',
  PASSWORD_REQUIRE_SYMBOL: 'Password must contain at least one symbol from the allowed set (, . ? ~ ! @ # $ % ^ & * _)',
  PASSWORD_INVALID_CHAR: 'Password contains a character that is not allowed. Use only letters, numbers, and allowed symbols',
  PASSWORD_CONTAINS_NAME: 'Password cannot contain your first, middle, or last name',
  PASSWORD_MISMATCH: 'Passwords must match',
  NO_SPECIAL_CHARACTERS: 'Cannot contain special characters',
  NO_SPECIAL_CHARACTERS_OR_NUMBERS: 'Cannot contain special characters or numbers',
  INVALID_PHONE_NUMBER: 'Invalid phone number',
  INVALID_DEVICE_ID: 'Device ID must be exactly 16 characters',
  DEVICE_ID_REQUIRED: 'Enter the meter\'s serial number: a meter cannot be registered without one',
  INVALID_SSN: 'Only last 4 digits of SSN',
};